/* src/app/component/flight-details/flight-details.component.scss */
/*# sourceMappingURL=flight-details.component-UPDQZEXX.css.map */
